import React from "react";
import type { FilterType, ProaceFilterType } from "../../../../../../../common-deprecated/types/CommonTypes";
import { useBnbSelector } from "../../../../redux/store";
import * as Input from "../../../../../../../common-deprecated/styles/v2/toyota/components/Input";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { ImageFluid } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Image";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";

type SeatFilterPropType = {
    filter: FilterType & { code: ProaceFilterType.SeatsCount };
    selectedValue: string;
    onSelect: (value: string) => void;
};

const SeatFilter = ({ filter, selectedValue, onSelect }: SeatFilterPropType): JSX.Element => {
    const resourcePath = useBnbSelector(({ commonSettings }) => commonSettings.resourcePath);
    return (
        <>
            <Type.H2 headingType="sub-epsilon" mb={3}>
                {filter.label}
            </Type.H2>
            {filter.values.map((value) => (
                <Flex.Col key={value.id} px={0} display="flex" alignItems="center" justifyContent="space-between">
                    <Input.Wrapper variant="radio">
                        <input
                            id={value.id}
                            key={value.id}
                            onClick={() => onSelect(value.id)}
                            checked={selectedValue === value.id}
                            readOnly
                        />
                        <Input.Radio htmlFor={value.id} checked={selectedValue === value.id}>
                            {value.label}
                        </Input.Radio>
                    </Input.Wrapper>

                    <ImageFluid
                        maxWidth="100px"
                        src={`${resourcePath}/toyota/svg/build-model-filter/proace-seats-${value.label}.svg`}
                        alt={`${filter.label}: ${value.label}`}
                    />
                </Flex.Col>
            ))}
        </>
    );
};

export default SeatFilter;
